jQuery(document).ready(function ($) {

    $('.js-slider-mockups').slick({
        dots: true,
        infinite: false,
        appendDots: $('.row-mockups__slider__dots')
    });

    const settings = {
        slidesToShow: 1,
        mobileFirst: true,
        autoplay: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 1030,
                settings: "unslick"
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 4,
                }
            },
            {
                breakpoint: 512,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    };

    const sliderElementor = $('.js-slider-elementor .elementor-container').slick(settings);

    $(window).on('resize', function () {
        if ($(window).width() <= 1030 && !sliderElementor.hasClass('slick-initialized')) {
            $('.js-slider-elementor .elementor-container').slick(settings);
        }
    });

});